import { useState } from 'react';
import { post } from '../../../api/baseUrl';
import { useDispatch, useSelector } from 'react-redux';
import { setClinicianTenancy } from '../../../store/ai2';
import { RootState } from '../../../store';

export const useUpdateUserDashboardColumns = () => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const postUserDashboardColumns = async (
    dashboardColumns: { id: string; enabled: any }[],
  ) => {
    setIsLoading(true);
    try {
      const { data } = await post(`updateUserFeatures`, { dashboardColumns });
      const { userDashboardColumns } = data.data.result;

      const newState = !selectedTenancy
        ? selectedTenancy
        : {
            ...selectedTenancy,
            features: { ...selectedTenancy.features, userDashboardColumns },
          };

      dispatch(setClinicianTenancy(newState));
      return data;
    } catch (error: any) {
      console.error(
        'An error occurred during update user dashboardColumns:',
        error,
      );
      setErrorMessage(
        error?.response?.data?.message ||
          'Unknown error in update user dashboardColumns',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { postUserDashboardColumns, errorMessage, isLoading };
};
